import settings from '@nobia/zeus-components/lib/settings'

window.dataLayer = window.dataLayer || []

const userId = document
  .getElementsByTagName('body')[0]
  .getAttribute('data-user-id')

const gtmDataPush = (data) => {
  if (!window?.dataLayer) {
    return
  }

  window.dataLayer.push(data)
}

export const marketoPageview = () => {
  if (!window.Munchkin) {
    return
  }

  window.Munchkin.munchkinFunction('visitWebPage', {})
}

export const gtmPageview = (path, title) => {
  const parsedPath = `${settings.basename}${path}`.replace('//', '/')
  const event = {
    event: 'myProject.pv',
    page: parsedPath,
    title,
    UID: userId,
  }

  gtmDataPush(event)
}

export const gtmEvent = (action, label, value) => {
  gtmDataPush({
    event: 'myProject.e',
    eventCategory: 'My Project',
    eventAction: action,
    eventLabel: label,
    eventValue: value,
    // UID: userId,
  })
}

export const gtmEventCustomized = (event, data) => {
  window.dataLayer.push({
    event: `myProject.${event}`,
    ...data
  })
}

export const gtmPaymentEvent = ({
  orderNumber,
  orderAmount,
  typeOfPayment,
}) => {
  gtmDataPush({
    event: 'payment',
    customerId: userId,
    orderId: orderNumber,
    value: orderAmount,
    type: typeOfPayment,
  })
}
